import React from "react";
import { message } from "antd";
import styled from "styled-components";
import { PlusOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Upload from "components/buttons/Upload";
import Input from "components/inputs/Input";
import Fetch from "components/Fetch";
// import ProductList from "./ProductList";
import Payment from "components/Modals/AdminManageOrder/Payment";
import { StyledModal } from "components/App/styled";
import Loading from "components/App/Loading";
export default function App({
  visible,
  setVisible,
  buttonStyle,
  reload,
  oldData,
}) {
  const [productList, setProductList] = React.useState(
    oldData ? JSON.parse(oldData.data)?.list : []
  );
  const [paymentList, setPaymentList] = React.useState(
    oldData ? JSON.parse(oldData.data)?.payments : []
  );
  const [info, setInfo] = React.useState(false);
  const [newCustomer, setNewCustomer] = React.useState(false);
  const [customer, setCustomer] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);
  const [image, setImage] = React.useState(
    oldData?.data ? JSON.parse(oldData.data).images : []
  );

  const added = paymentList
    .map((item) => item.amount)
    .reduce((a, b) => Number(a) + Number(b), 0);
  const remain =
    productList
      .map((item) => ({ amount: item.amount, price: item.price }))
      .reduce((a, b) => Number(a) + Number(b.amount) * Number(b.price), 0) -
    added;

  React.useEffect(() => {
    Fetch.get("/orders/data", (res) => {
      setInfo(res);
      oldData &&
        res.customers &&
        setCustomer(
          res.customers.findIndex((e) => e.name === oldData.customer)
        );
    });
  }, [oldData]);
  React.useEffect(() => {
    if (refresh) {
      setRefresh(false);
    }
  }, [newCustomer, refresh]);
  const showModal = () => {
    setVisible(true);
  };
  console.log("remainremainremainremain", remain);
  const onSubmit = () => {
    if (remain) {
      message.error("لطفا پرداختی ها را مشخص کنید");
      return false;
    }
    const data = {};
    setLoading(true);
    var submitData = {
      ...data,
      visitor: "reza",

      data: JSON.stringify({
        images: image,
        list: productList,
        payments: paymentList,
      }),
    };
    if (newCustomer) {
      var _response;
      Fetch.post(
        "/customer",
        { ...submitData, name: submitData.customer, shop: submitData.shop },
        (_response = (res) => {
          console.log("new customer response", res);
          if (res?.id) {
            return true;
          } else {
            if (res?.errors.name) {
              message.error(res?.errors.name[0]);
            } else {
              message.error("خطایی رخ داده است");
            }
            return false;
          }
        })
      );
      console.log("new customer +++++++", _response);
      if (!_response) {
        setLoading(false);
        return false;
      }
    } else {
      console.log(customer);
      const customerData = info.customers[customer];
      submitData = {
        ...submitData,
        customer: customerData.name,
        shop: customerData.shop,
        address: customerData.address,
        phone: customerData.phone,
      };
    }

    if (!oldData) {
      // new :::::::::::::
      Fetch.post("/orders", submitData, (res) => {
        console.log("manage order response", res);
        if (res?.id) {
          message.success("با موفقیت اضافه شد");
          cleanForm();
          setVisible(false);
          reload(true);
        } else {
          if (res?.errors.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    } else {
      // update :::::::::
      Fetch.put(`/orders/${oldData.id}`, submitData, (res) => {
        console.log("manage order response/ UPDATE", res);
        if (res?.ok) {
          message.success("با موفقیت آپدیت شد");
          cleanForm();
          setVisible(false);
          reload(true);
        } else {
          if (res?.errors?.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      });
    }
    setNewCustomer(false);
    setLoading(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const cleanForm = () => {
    setProductList([]);
    setPaymentList([]);
    setImage([]);
  };

  function newProductList(data) {
    setProductList(data);
    setRefresh(true);
  }
  function newPaymentList(data) {
    setPaymentList(data);
    setRefresh(true);
  }
  function newRemain(data) {
    setPaymentList(data);
    setRefresh(true);
  }

  if (!info || productList.length < 0 || paymentList.length < 0) {
    return (
      <>
        <Button
          shape="round"
          color={colors.blue}
          onClick={showModal}
          style={buttonStyle && buttonStyle}
        >
          {oldData ? (
            "به روز رسانی"
          ) : (
            <span>
              <PlusOutlined style={{ marginLeft: 8 }} />
              اضافه کردن سفارش
            </span>
          )}
        </Button>
        <StyledModal
          title={oldData ? "به روز رسانی" : " اضافه کردن سفارش"}
          visible={visible}
          onOk={onSubmit}
          onCancel={handleCancel}
          closable={false}
          footer={[
            <Button
              key="submit"
              type="primary"
              loading={loading}
              onClick={onSubmit}
              style={{ width: "100%" }}
              color={colors.blue}
            >
              ثبت
            </Button>,
          ]}
          width={680}
        >
          <Loading />
        </StyledModal>
      </>
    );
  }
  return (
    <>
      <Button
        shape="round"
        color={colors.blue}
        onClick={showModal}
        style={buttonStyle && buttonStyle}
      >
        {oldData ? (
          "به روز رسانی"
        ) : (
          <span>
            <PlusOutlined style={{ marginLeft: 8 }} />
            اضافه کردن سفارش
          </span>
        )}
      </Button>
      <StyledModal
        title={oldData ? "به روز رسانی" : " اضافه کردن سفارش"}
        visible={visible}
        onOk={onSubmit}
        onCancel={handleCancel}
        closable={false}
        footer={[
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={onSubmit}
            style={{ width: "100%" }}
            color={colors.blue}
          >
            ثبت
          </Button>,
        ]}
        width={680}
      >
        <ColContainer>
          <Col>
            <Label>نام مشتری :</Label>
            <Input
              size="large"
              placeholder={oldData && oldData.customer}
              disabled
            />
          </Col>
          <Col style={{ textAlign: "center" }}>
            <Upload maxAllowed={20} setImage={setImage} addedImages={image} />
          </Col>
        </ColContainer>
        {/* 
          <ProductList
            products={info.products}
            list={productList}
            setList={newProductList}
          />
  */}
        <Payment
          products={info.products}
          list={paymentList}
          setList={newPaymentList}
          productList={productList}
          productListLength={productList.length}
          remain={remain}
          orderId={oldData.id}
        />
      </StyledModal>
    </>
  );
}
const ColContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
`;
const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
